import { useParams } from "react-router-dom";
import { BoardView } from "../ws7/board/BoardView";
import "../ws7/ws7.css";

/** Monday-style board: /board/videos | songs | renders (WS7). */
export function BoardPage() {
  const { group = "videos" } = useParams();
  return <BoardView key={group} group={group} />;
}
